import React, { useEffect } from "react";
import { Select } from "antd";
import { Modal } from "react-bootstrap";
//css
import "./Modal.css";
import { Form } from "react-bootstrap";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import BtnSave from "../Commons/Buttons/BtnSave";
import TextArea from "../Commons/Forms/TextArea";
import { getRole, getUser } from "../Helpers/Utilities/Common";

const { Option } = Select;

function AddToQueueModal(props) {

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="row">
            <Form.Label className="form-title align-center">
              Refuse Admission
            </Form.Label>
            <p className="mt-1">Please provide a reason for refusing the admission:</p>
          </div>
          <div className="row mt-1">
            <TextArea
              name="reason"
              value={props?.refuseReason}
              onChange={props.onChange}
            />
          </div>
          <div className="row mt-4 right">
            <div className="col-6">
              <BtnDelete
                label={"Close"}
                size={"sm"}
                onClick={props.onHide}
                isClicked={props.isClicked}
              />
            </div>
            <div className="col-6">
              <BtnSave
                label={"Submit"}
                size={"sm"}
                onClick={props.onConfirm}
                isClicked={props.isClicked}
                disabled={props.refuseReason === ""}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AddToQueueModal;
